export default "__VITE_ASSET__gf0O0hgP__"